import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import paginationFactory from 'react-bootstrap-table2-paginator';

import settings from '../../settings'
import rotas from '../../services/rotas'
import Loading from 'lib/loading';
import './style.css';
import rest from 'lib/rest';
import Button from "reactstrap/lib/Button";
import Swal from "sweetalert2";
import ReactSelect from "components/Form/Select/Select";
import useForm from "lib/useForm";

const EntradaNFe = () => {
  const colunas = [
    {
      dataField: 'fantasia',
      text: 'Fantasia'
    },
    {
      dataField: 'nota_fiscal',
      text: 'Nota'
    },
    {
      dataField: 'motivo',
      text: 'Motivo'
    },
    {
      dataField: 'data_lancamento',
      text: 'Lançamento'
    },
    // {
    //   dataField: 'processada',
    //   text: 'Processada'
    // },
    {
      dataField: 'excluir',
      text: 'Excluir',
      formatter: (cell, row) => {
        if ((row.status_exclusao === 'N') && (row.retorno === 'S')) {
          return (
            <Button
              className="btn-icon btn-neutral"
              color="danger"
              id=""
              size="md"
              type="button"
              onClick={() => { excluirNota(row.chave_id) }}
            >
              <i className="fas fa-times" />
            </Button>
          )
        }
      }
    }

  ]
  //const data = []

  const inicialForm = {
    filialSelect: [],
  }

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalPaginacao, setTotalPaginacao] = useState(1);
  const [listaLojas, setListaLojas] = useState([]);
  const [filialId, setFilialId] = useState('');
  // const [form, onChangeSelect] = useForm(inicialForm)
  const [checkStatus, setCheckStatus] = useState({status:'P'});
  const [refresh, setRefresh] = useState(0);

  const { SearchBar } = Search;

  useEffect(() => {
    const load = loading;
    statusNfe();
    setLoading(false);
    listarLojas();
    if (load === true) {

    }
  }, [])

  const statusNfe = () => {
    const url = settings.url + rotas.statusNfe;
    let retorno = rest.get(url);
    retorno.then(ret => {
      if (ret.success) {
        //console.log(ret.retorno);
        setTotalPaginacao(ret.total);
        setData(ret.retorno);
        setLoading(false);
      }
    })
  }

  const excluirNota = (chave_id) => {

    Swal.fire({
      title: 'Confirmação',
      text: 'Confirma exclusão da nota?',
      icon: 'question',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      cancelButtonColor: '#d33'
    }).then((result) => {
      if (result.isConfirmed) {

        const parametros = {
          chave_id: chave_id,
          // excluir_duplicata: excluir_duplicata
        }
        const url = settings.url + rotas.excluiNfePainel;

        const retorno = rest.post(url, parametros);
        retorno.then(ret => {

          if (ret.success === 'S') {
            Swal.fire(
              'Sucesso',
              'Nota excluída com sucesso, aguarde a exclusão local',
              'success'
            )
          } else {
            Swal.fire(
              'Erro',
              'Erro ao excluir a nota',
              'error'
            )
          }
          setCheckStatus({status:'P'});
          statusNfe();
        })



        // Swal.fire({
        //   title: 'Confirmação',
        //   text: 'Excluir contas a pagar caso exista?',
        //   icon: 'question',
        //   showDenyButton: true,
        //   showCancelButton: true,
        //   confirmButtonText: 'Sim',
        //   cancelButtonText: 'Não',
        //   cancelButtonColor: '#d33'
        // }).then((result) => {

        //   let excluir_duplicata = 'N';

        //   if(result.isConfirmed){
        //     excluir_duplicata = 'S'  
        //   }else{
        //     excluir_duplicata = 'N'
        //   }

        //   const parametros = {
        //     chave_id: chave_id,
        //     excluir_duplicata: excluir_duplicata
        //   }
        //   const url = settings.url + rotas.excluiNfePainel;
  
        //   const retorno = rest.post(url, parametros);
        //   retorno.then(ret => {
  
        //     if (ret.success === 'S') {
        //       Swal.fire(
        //         'Sucesso',
        //         'Nota excluída com sucesso, aguarde a exclusão local',
        //         'success'
        //       )
        //     } else {
        //       Swal.fire(
        //         'Erro',
        //         'Erro ao excluir a nota',
        //         'error'
        //       )
        //     }
        //     setCheckStatus({status:'P'});
        //     statusNfe();
        //   })
        // })
      }
    })
  }

  const listarLojas = () => {
    let lista = [{ id: 0, title: 'TODAS' }]
    const url = rotas.lojas
    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != '') {
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i + 1] = { "id": ret.lista[i].filial_id, "title": ret.lista[i].fantasia }
          }
          setListaLojas(lista)
        }
      })
      return (true)
    } catch (err) {
      console.log(err)
    }
  }

  const changeSelect = (e) => {
    setFilialId(e.id);
    pesquisaNota('pagination', {page:1, filial_id:e.id})
  }

  const changeStatus = (e) =>{
    let status = checkStatus;
    status.status = e.target.value;

    let pParametros = {};

    if(filialId){
      pParametros = {
        page:1,
        filial_id:filialId
      }
    }else{
      pParametros = {
        page:1
      }  
    }

    setCheckStatus(status);
    setRefresh(refresh+1);
    pesquisaNota('pagination', pParametros)
  }

  const pesquisaNota = (type, filtros) => {
    if (type === 'search') {
      const pesquisa = filtros.searchText;

      if (pesquisa.length >= 3) {
        const url = settings.url + rotas.statusNfe;
        let retorno = rest.get(url + '?nota=' + pesquisa);
        retorno.then(ret => {
          if (ret.success) {
            // console.log(ret.retorno);
            setTotalPaginacao(1);
            setData(ret.retorno);
            setLoading(false);
          }
        })
      } else if (pesquisa.length === 0) {
        //type = 'pagination';
        statusNfe();
      }
    }

    if (type === 'pagination') {

      const pagina = filtros.page;

      let filtroFilial = '';

      console.log(filtros.filial_id);

      if((filtros.filial_id !== '')&&(filtros.filial_id !== 0)&&(filtros.filial_id!==undefined)){
        filtroFilial = '&filial_id=' + filtros.filial_id;
      }
      

      const url = settings.url + rotas.statusNfe;
      const retorno = rest.get(url + '?pagina=' + pagina + '&status=' + checkStatus.status + filtroFilial);
      retorno.then(ret => {
        //console.log(ret.total);
        setData(ret.retorno);
        setTotalPaginacao(ret.total);
      })
    }
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  } else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>CONSULTAR STATUS NFe</CardTitle>
                </CardHeader>
                <Row className='d-flex align-items-center'>
                  <Col md='6'>
                    <FormGroup className="mb-0 ml-3">
                      <ReactSelect
                        name="loja"
                        placeholder="Loja"
                        options={listaLojas}
                        // defaultValue={form.filialSelect}
                        onChange={(e) => { changeSelect(e) }}
                      // onClick={form.filialSelect ? form.filial_id = form.filialSelect.id : ''}
                      ></ReactSelect>
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <div className="card-2 mx-3">
                      <FormGroup
                        className="mb-0"
                      >
                        <Row className='d-flex align-items-center justify-content-around'>
                          <div className="form-check-radio  mb-0" >
                            <Label className="form-check-label">
                              <Input
                                type="radio"
                                name="status-notas"
                                id="nao-lancadas"
                                value="P"
                                checked={checkStatus.status === 'P' ? true : false}
                              //onChange={onChange('controle')}
                                onClick={changeStatus}
                              //disabled={checkControleEspecial}
                              />
                              Não Lançadas
                              <span className="form-check-sign"></span>
                            </Label>
                          </div>

                          <div className="form-check-radio mb-0" >
                            <Label className="form-check-label">
                              <Input
                                type="radio"
                                name="status-notas"
                                id="lancadas"
                                value="L"
                                checked={checkStatus.status === 'L' ? true : false}
                              //onChange={onChange('controle')}
                                onClick={changeStatus}
                              //disabled={checkControleEspecial}
                              />
                              Lançadas
                              <span className="form-check-sign"></span>
                            </Label>
                          </div>

                          <div className="form-check-radio mb-0" >
                            <Label className="form-check-label">
                              <Input
                                type="radio"
                                name="status-notas"
                                id="todas"
                                value="T"
                                checked={checkStatus.status === 'T' ? true : false}
                              //onChange={onChange('controle')}
                                onClick={changeStatus}
                              //disabled={checkControleEspecial}
                              />
                              Todas
                              <span className="form-check-sign"></span>
                            </Label>
                          </div>
                        </Row>
                      </FormGroup>
                    </div>
                  </Col>
                </Row>

                <CardBody>
                  <ToolkitProvider
                    keyField="nota_fiscal"
                    data={data}
                    columns={colunas}
                    cellEdit={cellEditFactory({ mode: 'click', blurToSave: true })}
                    search
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="12" className="p-0" >
                                <SearchBar
                                  placeholder="Buscar nota fiscal..."
                                  style={{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr />

                          <BootstrapTable
                            striped
                            keyField=''
                            noDataIndication="Nenhum registro encontrado"
                            rowStyle={{ cursor: "pointer" }}
                            pagination={paginationFactory({
                              sizePerPage: 20,
                              totalSize: totalPaginacao,
                              hideSizePerPage: true,
                              hidePageListOnlyOnePage: true,
                              showTotal: false,
                            })}
                            remote={{ search: true, pagination: true }}
                            onTableChange={pesquisaNota}
                            {...props.baseProps}
                          />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default EntradaNFe;